// export const API_BASE = "https://apis.hellopicbot.com/"
export const API_BASE = "https://apis.hellopicbot.com/getgabs/"
// export const API_BASE = "https://demo.vehub.live/whatsapp_rekog/"